const validateLogin = (inputs) => {
  const body = {};
  let errors = 0;
  inputs.forEach((input) => {
    if (!input.model) {
      input.error = input.emptyError;
      errors += 1;
    } else {
      input.error = false;
      body[input.modelName] = input.model;
    }
  });
  return errors === 0 ? body : false;
};

export default validateLogin;
